import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export const banUser = async (name,bannedStatus, userId) => {
    const token = localStorage.getItem("minebikers_token");
    if (!token || !userId) {
        console.log("Token puuttuu");
        return false;
      }
      try {
        const response = await makeCSRFRequest(
          `${BASE_URL}/vieraskirja/bannaa/${name}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({ userId: userId, bannedStatus: bannedStatus }),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to ban user");
        }
        return response.status;
      } catch (error) {
        console.error(error);
        return false;
      }
    };
    
